export const SAFARI_AR_READY = "SAFARI_AR_READY";
export const SAFARI_AR_READY_IOS_12 = "SAFARI_AR_READY_IOS_12";
export const IOS_VERSION_BELOW_12 = "IOS_VERSION_BELOW_12";
export const ANDROID_AR_READY = "ANDROID_AR_READY";
export const DESKTOP_BROWSER = "DESKTOP_BROWSER";
export const SAFARI_AR_NOT_READY = "SAFARI_AR_NOT_READY";
export const ANDROID_AR_NOT_READY = "ANDROID_AR_NOT_READY";
export const OTHER_DEVICE = "OTHER_DEVICE";